import {showErrorMessage} from "@/helper";

export default {
    getAll(style = 'default') {
        return new Promise((resolve, reject) => {
            http.get('api/strategies' + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/strategies/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    getStrategy(id, style = null) {
        return new Promise((resolve, reject) => {
            http.get('api/strategies/' + id + (style ? '?style=' + style : '')).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    saveStrategy(data, strategyId = null) {
        return new Promise((resolve, reject) => {
            http.post('api/strategies' + (strategyId ? '/' + strategyId : ''), data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deleteStrategy(strategyId) {
        return new Promise((resolve, reject) => {
            http.delete('api/strategies/' + strategyId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },

    deactivateStrategy(strategyId) {
        return new Promise((resolve, reject) => {
            http.post('api/strategies/' + strategyId + '/deactivate').then(response => {
                resolve(response.data);
            }).catch(error => {
                reject([]);
            });
        });
    },
}